// src/domains/broadcast.keys.ts —— 模板键归属（TD-823，agent-keys 用例按片 owner 推导核对）
// 片 0158（A-11 推广推送，Bot 广告推送 2026-10-21）整片为 dev:A-11 偏差块；全部动态值收拢在 bc 一个根键下
export const KEYS = ['bc'] as const;
export const MODAL_KEYS = [] as const;
